// src/components/Cards.js

import React from "react";
import "../styles/Home.css";

import { FaStore } from "react-icons/fa";

import {
  FiHeart,
  FiMessageCircle,
  FiShare2,
  FiMoreHorizontal,
  FiMapPin,
  FiPhone,
  FiClock,
  FiBookOpen,
  FiExternalLink,
} from "react-icons/fi";

import {
  FaUserCircle,
} from "react-icons/fa";

import { useAuth } from "../context/AuthContext";

/* ==========================================================
   HELPERS
========================================================== */

function stripHtml(html = "") {
  return html
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/g, " ")
    .replace(/&amp;/g, "&")
    .replace(/\s+/g, " ")
    .trim();
}

/* ==========================================================
   POST CARD
========================================================== */

export function PostCard({
  post,
  onClick,
  onLike,
  onShare,
}) {
  if (!post) return null;

  const {
    userName,
    userPhotoURL,
    profilePhoto,
    area,
    text,
    caption,
    imageUrl,
    videoUrl,
    likes = [],
    comments = 0,
    createdAt,
  } = post;

  const postText = text || caption || "";

  const likeCount = Array.isArray(likes)
    ? likes.length
    : likes || 0;

  const time = createdAt
    ? new Date(createdAt).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      })
    : "";

  return (
    <article
      className="feed-card"
      onClick={() => onClick?.(post)}
    >
      {/* ================= HEADER ================= */}

      <div className="feed-head">

        {userPhotoURL || profilePhoto ? (
          <img
            src={userPhotoURL || profilePhoto}
            alt={userName}
            className="feed-avatar"
          />
        ) : (
          <FaUserCircle className="feed-avatar-icon" />
        )}

        <div className="feed-user">

          <div className="feed-title">
            {userName || "Unknown User"}
          </div>

          <div className="feed-subtitle">

            <FiMapPin
              size={12}
              style={{
                marginRight: 4,
                verticalAlign: "middle",
              }}
            />

            {area || "All"}

            {" • "}

            {time}

          </div>

        </div>

        <FiMoreHorizontal className="feed-menu" />

      </div>

      {/* ================= TEXT ================= */}

      {postText && (
        <div className="feed-body">

          <div className="feed-description">
            {postText}
          </div>

        </div>
      )}

      {/* ================= IMAGE ================= */}

      {imageUrl && (
        <img
          src={imageUrl}
          alt=""
          className="feed-image"
        />
      )}

      {/* ================= VIDEO ================= */}

      {videoUrl && (
        <video
          src={videoUrl}
          className="feed-image"
          controls
          playsInline
          preload="metadata"
        />
      )}

      {/* ================= FOOTER ================= */}

      <div className="feed-footer">

        <div className="feed-actions">

           {/* <button
            className="feed-action"
            onClick={(e) => {
              e.stopPropagation();
              onLike?.(post);
            }}
          >
            <FiHeart />

            {likeCount > 0 && (
              <span>{likeCount}</span>
            )}
          </button>

          <button
            className="feed-action"
            onClick={(e) => e.stopPropagation()}
          >
            <FiMessageCircle />

            {comments > 0 && (
              <span>{comments}</span>
            )}
          </button>  */}

          <button
            className="feed-action"
            onClick={(e) => {
              e.stopPropagation();
              onShare?.(post);
            }}
          >
            <FiShare2 />

            <span>Share</span>
          </button>

        </div>

      </div>

    </article>
  );
}

/* ==========================================================
   PRODUCT CARD
========================================================== */

export function ProductCard({
  product,
  onClick,  
}) {
  const { user } = useAuth();

  if (!product) return null;

  const variants = Array.isArray(product.variants)
    ? product.variants
    : [];

  const variant = variants[0] || {};

  const image =
    variant.image ||
    product.image ||
    "https://via.placeholder.com/600x600?text=Product";

  const price = Number(
    variant.price || product.price || 0
  );

  const mrp = Number(
    variant.mrp || product.mrp || 0
  );

  const discount =
    mrp > price
      ? Math.round(((mrp - price) / mrp) * 100)
      : 0;

  const handleRefer = async (e) => {
    e.stopPropagation();

    if (!user) {
      alert("Please login to refer products.");
      return;
    }

    const link =
      `${window.location.origin}/product/${product.product_id}?ref=${user.uid}`;

    if (navigator.share) {
      try {
        await navigator.share({
          title: product.name,
          text: `Check out "${product.name}" on Eyal App`,
          url: link,
        });
        return;
      } catch {}
    }

    try {
      await navigator.clipboard.writeText(link);
      alert("Referral link copied.");
    } catch {
      window.prompt(
        "Copy Referral Link",
        link
      );
    }
  };

  return (
    <article
      className="feed-card"
      onClick={() => onClick?.(product)}
    >

      {/* ================= HEADER ================= */}

      <div className="feed-head">

        <img
          src={image}
          alt={product.name}
          className="feed-avatar"
        />

        <div className="feed-user">

          <div className="feed-title">
            {product.name}
          </div>

          <div className="feed-subtitle">
            {product.brand || "Eyal Store"}

            {product.category && (
              <>
                {" • "}
                {product.category}
              </>
            )}
          </div>

        </div>

        <FiMoreHorizontal className="feed-menu" />

      </div>

      {/* ================= IMAGE ================= */}

      <img
        src={image}
        alt={product.name}
        className="feed-image"
      />

      {/* ================= BODY ================= */}

      <div className="feed-body">

        {product.description && (
          <div className="feed-description">
            {product.description}
          </div>
        )}

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            marginTop: 12,
            flexWrap: "wrap",
          }}
        >

          <div className="price-current">
            ₹{price}
          </div>

          {mrp > price && (
            <>
              <div className="price-old">
                ₹{mrp}
              </div>

              <span
                style={{
                  background: "#EF4444",
                  color: "#fff",
                  padding: "4px 8px",
                  borderRadius: 8,
                  fontSize: 12,
                  fontWeight: 700,
                }}
              >
                {discount}% OFF
              </span>
            </>
          )}

        </div>

      </div>

      {/* ================= FOOTER ================= */}

      <div className="feed-footer">

        
        <div
  style={{
    marginTop: 14,
  }}
>
  <button
    className="feed-button"
    style={{ width: "100%" }}
    onClick={(e) => {
      e.stopPropagation();
      onClick?.(product);
    }}
  >
    View Product
  </button>
</div>

        <button
          className="feed-button"
          style={{
            marginTop: 10,
            background: "#16A34A",
          }}
          onClick={handleRefer}
        >
          💰 Refer & Earn
        </button>

      </div>

    </article>
  );
}

/* ==========================================================
   SHOP CARD
========================================================== */

export function ShopCard({
  shop,
  onClick,
  onCall,
  onShare,
}) {
  if (!shop) return null;

  const {
    ["Shop Name"]: shopName,
    ["Shop Image"]: shopImage,
    ["Mobile Number"]: mobile,
    ["Type (Premium/Normal)"]: type,
    Location,
    Category,
    Description,
    Address,
    ["Opening Time"]: openingTime,
    ["Closing Time"]: closingTime,
    Likes = 0,
  } = shop;

  const image =
    shop["Shop Image"] ||
    shop["Shop image"] ||
    shop.shopImage ||
    shop.image ||
    shop.imageUrl ||
    "";

  const isPremium = type === "Premium";

  const handleShare = async (e) => {
    e.stopPropagation();

    const link =
      `${window.location.origin}/shop/${shop.id}`;

    if (navigator.share) {
      try {
        await navigator.share({
          title: shopName,
          text: `${shopName}\n${Location || ""}`,
          url: link,
        });
        return;
      } catch {}
    }

    window.open(
      `https://wa.me/?text=${encodeURIComponent(
        `${shopName}\n${link}`
      )}`,
      "_blank"
    );

    onShare?.(shop);
  };

  return (
    <article
      className="feed-card"
      onClick={() => onClick?.(shop)}
    >

      {/* ================= HEADER ================= */}

      <div className="feed-head">

        {image ? (
    <img
        src={image}
        alt={shopName}
        className="feed-avatar"
    />
) : (
    <div className="feed-avatar-icon">
        <FaStore />
    </div>
)}

        <div className="feed-user">

          <div className="feed-title">
            {shopName}
          </div>

          <div className="feed-subtitle">

            <FiMapPin
              size={12}
              style={{ marginRight: 4 }}
            />

            {Location || "Local"}

            {Category && (
              <>
                {" • "}
                {Category}
              </>
            )}

          </div>

        </div>

        <FiMoreHorizontal className="feed-menu" />

      </div>

      {/* ================= IMAGE ================= */}

{image ? (
    <img
        src={image}
        alt={shopName}
        className="feed-image"
    />
) : (
    <div className="shop-placeholder">

    <FaStore className="shop-placeholder-icon" />

    <div className="shop-placeholder-title">
        {shopName}
    </div>

    <div className="shop-placeholder-subtitle">
        {Category || "Local Business"}
    </div>

</div>
)}

      {/* ================= BODY ================= */}

      <div className="feed-body">

        {isPremium && (
          <div className="badge badge-warning">
            ⭐ Premium Shop
          </div>
        )}

        {Description && (
          <div className="feed-description">
            {Description}
          </div>
        )}

        {Address && (
          <div
            className="feed-description"
            style={{ marginTop: 8 }}
          >
            📍 {Address}
          </div>
        )}

        {(openingTime || closingTime) && (
          <div
            className="feed-description"
            style={{
              display: "flex",
              alignItems: "center",
              gap: 6,
              marginTop: 8,
            }}
          >
            <FiClock />

            {openingTime || "--:--"}

            {" - "}

            {closingTime || "--:--"}
          </div>
        )}

      </div>

      {/* ================= FOOTER ================= */}

      <div className="feed-footer">

        <div className="feed-actions">

          {/* <button
            className="feed-action"
            onClick={(e) => e.stopPropagation()}
          >
            <FiHeart />
            {Likes || ""}
          </button> */}

          <button
            className="feed-action"
            onClick={handleShare}
          >
            <FiShare2 />
            Share
          </button>

          <button
            className="feed-action"
            onClick={(e) => {
              e.stopPropagation();

              if (onCall) {
                onCall(shop);
              } else if (mobile) {
                window.location.href = `tel:${mobile}`;
              }
            }}
          >
            <FiPhone />
            Call
          </button>

        </div>

      </div>

    </article>
  );
}

/* ==========================================================
   NEWS CARD
========================================================== */

export function NewsCard({
  news,
  onClick,
  onShare,
  hideReadMore = false,
}) {
  if (!news) return null;

  const {
    title,
    description,
    text,
    imageUrl,
    area,
    source,
    createdAt,
  } = news;

  const time = formatDate(createdAt);

  const handleShare = async (e) => {
    e.stopPropagation();

    const link =
      `${window.location.origin}/localupdates`;

    const shareText = `${title || "Local Update"}

${description || text || ""}

${link}`;

    if (navigator.share) {
      try {
        await navigator.share({
          title: title || "Local Update",
          text: shareText,
          url: link,
        });
        return;
      } catch {}
    }

    window.open(
      `https://wa.me/?text=${encodeURIComponent(
        shareText
      )}`,
      "_blank"
    );

    onShare?.(news);
  };

  return (
    <article
      className="feed-card"
      onClick={() => onClick?.(news)}
    >
      {/* Header */}

      <div className="news-header">

        <span className="news-badge">
          {area || source || "Local"}
        </span>


      </div>

      {/* Optional Image */}

      {imageUrl && (
        <img
          src={imageUrl}
          alt={title}
          className="feed-image"
        />
      )}

      {/* Content */}

      <div className="feed-body">

        <h2 className="news-title">
          {title || "Local Update"}
        </h2>

        {(description || text) && (
          <div className="news-description">
            {description || text}
          </div>
        )}

      </div>

      {/* Footer */}

      <div className="news-footer">

        <div className="news-date">
          {time}
        </div>

        <div
          style={{
            display: "flex",
            gap: 10,
          }}
        >

          <button
            className="news-share"
            onClick={handleShare}
          >
            <FiShare2 />
          </button>

          {!hideReadMore && (
  <button
    className="news-button"
    onClick={(e) => {
      e.stopPropagation();
      onClick?.(news);
    }}
  >
    Read More →
  </button>
)}

        </div>

      </div>

    </article>
  );
}

/* ==========================================================
   INFO EXCHANGE CARD
========================================================== */
export function InfoCard({
  article,
  onClick,
  onShare,
}) {
  if (!article) return null;

  const {
    title,
    description,
    content,
    category,
    imageUrl,
    createdAt,
  } = article;

  const time = formatDate(createdAt);

  const handleShare = async (e) => {
    e.stopPropagation();

    const link =
      `${window.location.origin}/ie`;

    const shareText = `${title || "Info Exchange"}

${description || content || ""}

${link}`;

    if (navigator.share) {
      try {
        await navigator.share({
          title: title || "Info Exchange",
          text: shareText,
          url: link,
        });
        return;
      } catch {}
    }

    window.open(
      `https://wa.me/?text=${encodeURIComponent(
        shareText
      )}`,
      "_blank"
    );

    onShare?.(article);
  };

  return (
    <article
      className="feed-card"
      onClick={() => onClick?.(article)}
    >
      {/* Header */}

      <div className="news-header">

        <span className="news-badge">
          {category || "Technology"}
        </span>

       

      </div>

      {/* Image */}

      {imageUrl && (
        <img
          src={imageUrl}
          alt={title}
          className="feed-image"
        />
      )}

      {/* Body */}

      <div className="feed-body">

        <h2 className="news-title">
          {title || "Info Exchange"}
        </h2>

        {(description || content) && (
          <div className="news-description">
            {description || content}
          </div>
        )}

      </div>

      {/* Footer */}

      <div className="news-footer">

        <div className="news-date">
          {time}
        </div>

        <div
          style={{
            display: "flex",
            gap: 10,
          }}
        >

          <button
            className="news-share"
            onClick={handleShare}
          >
            <FiShare2 />
          </button>

          <button
            className="news-button"
            onClick={(e) => {
              e.stopPropagation();
              onClick?.(article);
            }}
          >
            Read More →
          </button>

        </div>

      </div>

    </article>
  );
}

/* ==========================================================
   HELPER FUNCTIONS
========================================================== */

function formatDate(date) {
  if (!date) return "";

  try {
    if (date.toDate) {
      date = date.toDate();
    }

    return date.toLocaleString("en-IN", {
      day: "numeric",
      month: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit",
    });
  } catch {
    return "";
  }
}

export function shuffleArray(array = []) {
  const items = [...array];

  for (let i = items.length - 1; i > 0; i--) {
    const j = Math.floor(
      Math.random() * (i + 1)
    );

    [items[i], items[j]] = [
      items[j],
      items[i],
    ];
  }

  return items;
}